import type { UnlayerDesign } from "../types/unlayer-design";

type UnlayerPollValues = {
  pollId?: string;
  question?: string;
  pollOptions?: string;
  [key: string]: unknown;
};

type UnlayerPollBlock = {
  type?: string;
  values?: UnlayerPollValues;
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return !!value && typeof value === "object";
}

export function getUnlayerPollBlocks(design: UnlayerDesign): UnlayerPollBlock[] {
  const blocks: UnlayerPollBlock[] = [];

  function collect(value: unknown): void {
    if (Array.isArray(value)) {
      value.forEach(collect);
      return;
    }

    if (!isRecord(value)) return;

    if (typeof (value as UnlayerPollBlock).values?.pollOptions === "string") {
      blocks.push(value);
      return;
    }

    Object.values(value).forEach(collect);
  }

  collect(design);
  return blocks;
}
